/*
 * File: DeleteButton.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 08 Jun 2022 5:02:53 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Button } from 'antd';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteSalesOrderMutation } from 'redux/services/useMamaBearService';

interface PostButtonProps {
  areAllStepsCompleted: boolean;
}

export const DeleteButton: FC<PostButtonProps> = ({ areAllStepsCompleted }: PostButtonProps) => {
  const { pathname } = useLocation();
  const [deleteSalesOrder, { isLoading }] = useDeleteSalesOrderMutation();
  const navigate = useNavigate();

  const productSalesOrderId = pathname.split('/')[2];

  const handleSubmit = async (): Promise<void> => {
    try {
      await deleteSalesOrder({ productSalesOrderId });
      navigate('/');
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Button onClick={handleSubmit} danger type="ghost">
      Delete
    </Button>
  );
};
